import {
    SUBMIT_LOGIN_INFO_SUCCESS
} from './actionTypes';

export function loginSubmitSuccess(token) {
    return {
        type: SUBMIT_LOGIN_INFO_SUCCESS,
        token
    }
}